<template>
  <div class="noShadow" v-loading="isLoading">
    <div class="searchBar">
      <div class="searchLeft">
        <el-popover placement="right-bottom" title="条件检索" trigger="click" v-model="searchVisible">
          <searchForm
            @startSearch="handleTableSearch"
            @cancleSearch="handleCancleSeach"
            @showSearchForm="showSearchForm"
          ></searchForm>
          <el-button slot="reference" size="mini">按条件筛选</el-button>
        </el-popover>
        <navTopTag :searchTagList="searchTagList" @handleDelOne="handleDelOne"></navTopTag>
      </div>
    </div>

   
    <div>
      <el-tabs v-model="allTableObj.currentTab" @tab-click="tabClick($event)">
        <el-tab-pane label="所有数据" name="all" ref="all" id="allTab"></el-tab-pane>
        <el-tab-pane label="搜索结果" name="search"></el-tab-pane>
      </el-tabs>
      <div class="tableContainer">
        <baseTable
          :columns="allTableObj.columns"
          :dataList="allTableObj.dataList"
          :options="allTableObj.options"
          :loadObj="allTableObj.loadObj"
          :operationColumn="allTableObj.operationColumn"
          :fenyeObj="allTableObj.fenyeObj"
          @dataSizeChange="handleSizeChange($event,allTableObj)"
          @dataCurrentChange="handleCurrentChange($event,allTableObj)"
        ></baseTable>
      </div>
    </div>
    <el-dialog :visible.sync="showOrderDetail" center title="订单详情" :append-to-body="true">
      <el-form size="mini" labelWidth="150px" labelPosition="right" :model="detailObj">
        <el-form-item label="创建时间">
          <span>{{detailObj.createTime}}</span>
        </el-form-item>
        <el-form-item label="服务对象">
          <span>{{detailObj.theOldName}}</span>
        </el-form-item>
        <el-form-item label="订单类型">
          <span>{{detailObj.type|orderTypeFilter}}</span>
        </el-form-item>
        <el-form-item label="订单编号">
          <span>{{detailObj.orderCode}}</span>
        </el-form-item>
        <el-form-item label="订单状态">
          <span>{{detailObj.status|orderStatusFilter}}</span>
        </el-form-item>
        <el-form-item label="金额">
          <span>{{detailObj.money}}</span>
        </el-form-item>
        <el-form-item label="个人账户自付">
          <span>{{detailObj.personPayMoney}}</span>
        </el-form-item>
        <el-form-item label="基础补助扣款">
          <span>{{detailObj.grantPayMoney}}</span>
        </el-form-item>
        <!-- <el-form-item label="孝善基金扣款">
          <span>{{detailObj.fundPayMoney}}</span>
        </el-form-item>-->
        <el-form-item label="服务商名称">
          <span>{{detailObj.providerName}}</span>
        </el-form-item>
        <el-form-item label="服务人员姓名">
          <span>{{detailObj.staffName}}</span>
        </el-form-item>
        <el-form-item label="接单时间">
          <span>{{detailObj.dispathTime}}</span>
        </el-form-item>
        <el-form-item label="服务时间">
          <span>{{detailObj.serviceTime}}</span>
        </el-form-item>
        <el-form-item label="账单结算状态">
          <span>{{detailObj.settleStatus}}</span>
        </el-form-item>
        <el-form-item label="评价状态">
          <span>{{detailObj.evaluationStatus}}</span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import searchForm from "./_component/search-form";
import { request } from "https";
// import $ from "jquery";
import { getOlderList, delOneOrg, getProviderEval, getServiceOrder } from "@/services/all-api.js";
import { mapState } from "vuex";
export default {
  components: {
    searchForm
  },
  computed: {
    ...mapState(["oneOlder"])
  },
  data() {
    return {
      showOrderDetail: false,
      detailObj: {},
      isLoading: false,
      searchTagList: [],
      searchVisible: false,
      allTableObj: {
        columns: [
          {
            prop: "num",
            label: "#",
            width: "60px",
            align: "center"
          },
          {
            prop: "createTime",
            label: "下单时间",
            width: "160px",
            align: "center"
          },
          {
            prop: "orderCode",
            label: "订单编号",
            width: "200px",
            align: "center"
          },
          {
            prop: "theOldName",
            label: "服务对象",
            align: "center"
          },
          {
            prop: "money",
            label: "金额",
            align: "center"
          },
          {
            prop: "personPayMoney",
            label: "个人账户自付",
            align: "center"
          },
          {
            prop: "grantPayMoney",
            label: "基础补助扣款",
            align: "center"
          },
          // {
          //   prop: "fundPayMoney",
          //   label: "孝善基金扣款",
          //   align: "center"
          // },
          {
            prop: "staffName",
            label: "服务人员",
            align: "center"
          },
          {
            prop: "status",
            label: "订单状态",
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: params.row.stauts === 5 ? "" : "color:#67C23A"
                },
                params.row.status === 0
                  ? "待支付"
                  : params.row.status === 1
                    ? "已支付"
                    : params.row.status === 2
                      ? "待分派"
                      : params.row.status === 3
                        ? "已派单"
                        : params.row.status === 4
                          ? "服务中"
                          : params.row.status === 5
                            ? "已完成"
                            : params.row.status === 6
                              ? "待评价"
                              : params.row.status === 7
                                ? "已评价"
                                : params.row.status === 8
                                  ? "已关闭"
                                  : ""
              );
            }
          },
          {
            prop: "settleStatus",
            label: "结算状态",
            align: "center"
          }
        ],
        dataList: [],
        options: {
          stripe: true,
          highlightCurrentRow: true,
          headStyleMethod: this.getTableHead
        },
        loadObj: {
          isLoading: false
        },
        allDataNow: {
          currentPage: 1,
          pageSize: 20,
          dataList: [],
          total: 0
        },
        searchDataNow: {
          currentPage: 1,
          pageSize: 20,
          searchObj: {},
          dataList: [],
          total: 0
        },
        operationColumn: {
          show: true,
          align: "center",
          width: "200px",
          btns: [
            {
              size: "mini",
              icon: "el-icon-tickets",
              type: "text",
              disabled: false,
              style: "font-size:16px",
              method: (index, row) => {
                this.handleDetail(index, row);
              }
            }
          ]
        },
        fenyeObj: {
          showPage: true,
          currentPage: 1,
          pageSize: 20,
          layoutString: "total,sizes,prev,pager,next,jumper",
          total: 0
        },
        currentTab: "all",
        searchObj: {}
      }
    };
  },
  methods: {
   
    showSearchForm() {
      this.searchVisible = true;
    },
    listTrans(obj) {
      const result = {
        data: obj.data.map((item, i) => ({
          gid: item.gid,
          num: obj.index * obj.size + i + 1,
          theOldGid: item.theOldGid,
          theOldName: item.theOldName,
          createTime: item.createTime,
          status: item.status,
          type: item.type,
          orderCode: item.code,
          money: item.payment,
          personPayMoney: item.personPayment,
          grantPayMoney: item.grantPayment,
          fundPayMoney: item.fundPayment,
          providerGid: item.serviceProviderGid,
          providerName: item.serviceProviderName,
          projectSku: item.serviceItemSkuInfos,
          staffGid: item.servicepersonalgid || "-",
          staffName: item.servicePersonalName || "-",
          settleStatus: item.billStatus === true ? "已结算" : "未结算",
          dispathTime: item.dispathTime || "-",
          serviceTime: item.serviceTime || "-",
          evaluationStatus: item.evaluationStatus || "-"
        })),
        total: obj.total,
        index: obj.index,
        size: obj.size
      };
      return result;
    },
    firstGet(obj) {
      this.isLoading = true;
      const reqObj = {
        index: 0,
        size: 20,
        theoldgid: this.oneOlder.theOldGid
      };
      getServiceOrder(reqObj).then(res => {
        this.isLoading = false;
        const result = this.listTrans(res.data);
        obj.dataList = result.data;
        obj.allDataNow.dataList = result.data;
        obj.allDataNow.total = result.total;
        obj.allDataNow.currentPage = result.index + 1;
        obj.allDataNow.pageSize = result.size;
        obj.fenyeObj.total = result.total;
        obj.fenyeObj.currentPage = result.index + 1;
        obj.fenyeObj.pageSize = result.size;
      });
    },
    handleTableSearch(i) {
      this.searchVisible = i.searchShow;
      this.searchTagList = this.getTagList(
        this.getOrderSearch(),
        i.searchData
      );
      this.$store.commit("setSearchForm", i.searchData);
      this.allTableObj.searchObj = i.searchData;
      this.allTableObj.currentTab = "search";
      const reqObj = {
        index: 0,
        size: 20,
        type: 1,
        ...i.searchData,
        startTime: !i.searchData.timeRange ? "" : i.searchData.timeRange[0],
        endTime: !i.searchData.timeRange ? "" : i.searchData.timeRange[1],
      };
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleCancleSeach(i) {
      this.searchVisible = i.searchShow;
    },
    handleDelOne(i) {
      //减少一个检索条件时
      this.searchTagList = this.searchTagList.filter((item, index) => {
        if (item[0] === i[0]) {
          return false;
        } else {
          return true;
        }
      });
      const obj = this.deleteOneSearch(
        i[0],
        this.$store.state.currentSearchForm
      );
      if (this.$baseFunc.paramsValidate(obj)) {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.searchDataNow.dataList = [];
        this.allTableObj.searchDataNow.currentPage = 1;
        this.allTableObj.searchDataNow.pageSize = 20;
        this.allTableObj.searchDataNow.total = 0;
        this.allTableObj.currentTab = "all";
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      } else {
        const reqObj = {
          index: 0,
          size: 20,
          type: 1,
          ...obj,
          startTime: !obj.timeRange ? "" : obj.timeRange[0],
          startTime: !obj.timeRange ? "" : obj.timeRange[1]
        };
        this.pageSearchGet(reqObj, this.allTableObj);
      }
      this.$store.commit("setSearchForm", obj);
    },
    tabClick(i) {
      if (i.name == "all") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.allDataNow.dataList;
        this.allTableObj.fenyeObj.total = this.allTableObj.allDataNow.total;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.allDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.allDataNow.pageSize;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
      if (i.name == "search") {
        this.allTableObj.fenyeObj.showPage = false;
        this.allTableObj.dataList = this.allTableObj.searchDataNow.dataList;
        this.allTableObj.fenyeObj.currentPage = this.allTableObj.searchDataNow.currentPage;
        this.allTableObj.fenyeObj.pageSize = this.allTableObj.searchDataNow.pageSize;
        this.allTableObj.fenyeObj.total = this.allTableObj.searchDataNow.total;
        this.$nextTick(() => {
          this.allTableObj.fenyeObj.showPage = true;
        });
      }
    },
    firstGetAll(obj) {
      obj.loadObj.isLoading = true;
      let reqObj = {
        allObj: obj.allDataNow
      };
      dataApi
        .firstGet(reqObj)
        .then(res => {
          //先缓存
          obj.allDataNow.dataList = res.allData.data;
          obj.allDataNow.total = res.allData.total;
          //最后赋值  默认全部
          obj.dataList = res.allData.data;
          obj.fenyeObj.total = res.allData.total;
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    //检索条件或者分页等变化时请求数据
    pageSearchGet(reqobj, obj) {
      const flag = obj.currentTab;
      obj.loadObj.isLoading = true;
      reqobj.theOldGid = this.oneOlder.theOldGid
      getServiceOrder({ ...reqobj, theOldGid: this.oneOlder.theOldGid })
        .then(res => {
          let transData = this.listTrans(res.data).data
          if (flag == "all") {
            obj.allDataNow.dataList = transData;
            obj.allDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.allDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.allDataNow.pageSize;
            obj.dataList = transData;
            obj.fenyeObj.total = obj.allDataNow.total;
            return false;
          } else if (flag == "search") {
            obj.searchDataNow.dataList = transData;
            obj.searchDataNow.total = res.data.total;
            obj.fenyeObj.currentPage = obj.searchDataNow.currentPage;
            obj.fenyeObj.pageSize = obj.searchDataNow.pageSize;
            obj.dataList = transData;
            obj.fenyeObj.total = obj.searchDataNow.total;
            return false;
          }
        })
        .finally(() => {
          obj.loadObj.isLoading = false;
        });
    },
    //每次页面码数变了 要变回第一页
    handleSizeChange(i, obj) {
      let reqObj = {};
      if (obj.currentTab == "all") {
        obj.allDataNow.currentPage = 1;
        obj.allDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
        };
      } else if (obj.currentTab == "search") {
        obj.searchDataNow.currentPage = 1;
        obj.searchDataNow.pageSize = i;
        reqObj = {
          index: 0,
          size: i,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    },
    handleDetail(i, j) {
      this.showOrderDetail = true;
      this.detailObj = {
        ...j
      }
    },
    handleCurrentChange(i, obj) {
      let reqObj = {};
      let flag = obj.currentTab;
      if (flag == "all") {
        obj.allDataNow.currentPage = i;
        obj.allDataNow.pageSize = obj.allDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.allDataNow.pageSize,
          type: 1
        };
      } else if (flag == "search") {
        obj.searchDataNow.currentPage = i;
        obj.searchDataNow.pageSize = obj.searchDataNow.pageSize;
        reqObj = {
          index: i - 1,
          size: obj.searchDataNow.pageSize,
          type: 1,
          ...this.$store.state.currentSearchForm
        };
      }
      this.pageSearchGet(reqObj, this.allTableObj);
    }
  },
  created() { },
  mounted() {
    this.firstGet(this.allTableObj);
  }
};
</script>
<style lang="scss" scoped>
.outDiv {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #ebeef5;
  padding: 20px;
  display: flex;
  flex-flow: column;
}
.searchBar {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  .searchLeft {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
}
.noShadow {
  box-shadow: 0 0 0 0;
  border: 0;
  padding: 20px 0px;
}
.tableContainer {
  height: calc(100vh - 380px);
}
.tableContainer > div {
  height: 90%;
}
</style>

